import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import categoryService from "../../../../api/Category/CategoryService";
export default class UpdateCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allAvaliableCategories: [],
      file: null,
      selectedCategory: {
        id: null,
        name: "",
        ar_name: "",
      },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllCategories();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };
  getAllCategories = () => {
    this.setState({ allAvailableCategories: [] });
    categoryService
      .getAllCategories()
      .then((res) => {
        res.data.map((cat, i) => {
          console.log("category:", cat);
          return this.setState({
            allAvailableCategories: [
              ...this.state.allAvailableCategories,
              {
                key: i + 1,
                id: cat.id,
                name: cat.name,
                ar_name: cat.ar_name,
              },
            ],
          });
        });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };
  onFileSelect = (e) => {
    this.setState({ file: e.target.files[0] });
  };
  selectCategories = () => {
    return this.state.allAvailableCategories?.map((cat) => {
      return <option value={cat.id}>{cat.name}</option>;
    });
  };

  onSelectCategory = (e) => {
    this.state.allAvailableCategories.map(
      (cat) =>
        e.target.value === cat.id &&
        this.setState({
          selectedCategory: {
            id: cat.id,
            name: cat.name,
            ar_name: cat.ar_name,
          },
        })
    );
  };

  updateCategory = () => {
    console.log("selected category", this.state.selectedCategory);
    const formData = new FormData();
    formData.append("document", this.state.file);
    formData.append("name", this.state.selectedCategory.name);
    formData.append("ar_name", this.state.selectedCategory.ar_name);
    categoryService.updateCategory(this.state.selectedCategory.id, formData);
    document.getElementById("name").value = "";
    document.getElementById("ar_name").value = "";
    toast.success(`Category Updated Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getAllCategories();
  };

  onChangeCategoryData = (e) => {
    let selectedCategory = this.state.selectedCategory;
    selectedCategory[e.target.name] = e.target.value;
    this.setState({ selectedCategory });
  };

  render() {
    let selectCategories = this.selectCategories();
    return (
      <>
        <Row>
          <Col>
            <h5 className="m-0">Update Category</h5>
          </Col>
          <Col>
            <div class="form-group" id="role">
              <select
                class="form-control"
                id="role"
                onChange={this.onSelectCategory}
              >
                <option value="#">Select Category</option>
                {selectCategories}
              </select>
            </div>
          </Col>
        </Row>
        <Row form>
          <Col md="6" className="form-group">
            <FormGroup controlId="img" id="create-user">
              <FormControl
                autoFocus
                type="file"
                name="img"
                id="img"
                onChange={this.onFileSelect.bind(this)}
              />
            </FormGroup>
            <FormGroup controlId="email">
              <label>Category Name</label>
              <FormControl
                autoFocus
                type="text"
                id="name"
                name="name"
                defaultValue={this.state.selectedCategory.name}
                onChange={this.onChangeCategoryData}
              />
            </FormGroup>
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Category Name</label>
              <FormControl
                autoFocus
                type="text"
                name="ar_name"
                id="ar_name"
                defaultValue={this.state.selectedCategory.ar_name}
                onChange={this.onChangeCategoryData}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.updateCategory}
            >
              Update
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
